import styled from 'styled-components';
import { Body4 } from '../../../common/typography';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
`;
export const SubDepartmentTitle = styled(Body4)`
  display: flex;
  text-transform: capitalize;
`;
